<template>
  <div style="margin-top: -4px;">
  <div class="homePage">
    <van-row style="font-size:16px;background-color:#009CE3;line-height:48px;color:white">
      <h2 class="title" style="margin:2px;font-size:18px">仓储管理</h2>
    </van-row>
    <van-row style="margin-top:16px;padding-bottom: 40px;">
      <van-grid :column-num="2" :gutter="12">
        <van-grid-item icon="todo-list" text="其他入库"  to="/enterStore" style="color:#FAC20D"/>
        <van-grid-item icon="todo-list" text="其他出库"  to="/outOfStore"  style="color:#0D79C4"/>
        <van-grid-item icon="todo-list" text="移动盘点"  to="/storeCheck"  style="color:#0D79C4"/>
        <van-grid-item icon="todo-list" text="库存查询"  to="/storeQuery"  style="color:#31AB1C"/>
        <van-grid-item icon="todo-list" text="比对调拨"  to="/compareAllocate" style="color:#0D79C4"/>
        <van-grid-item icon="todo-list" text="直接调拨"  to="/absoluteAllocate" style="color:#31AB1C"/>
      </van-grid>
    </van-row>
  </div>
    </div>

</template>

<script>
import dateUtil from "../../../util/dateTimeUtil";
import { mapState } from 'vuex'
import Vue from 'vue';
import store from '../../../store/index'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable)
let cnNumberArray = ["日","一", "二", "三", "四", "五", "六"];
export default {
components: {
},
computed: {
  tableHeight(){
    return window.innerHeight - 420;
  }
},
data() {
  return {
    curDate: "",
    curTime: "",
    curWeekDay: cnNumberArray[new Date().getDay()],
  };
},
async mounted(){
  this.loadCurTime();
  setInterval(() => {
    this.loadCurTime();
  }, 1000);
},
methods: {
  loadCurTime() {
    let curFullTime = dateUtil.defaultFullTimeFormate(new Date(), "/");
    this.curDate = curFullTime.split(" ")[0];
    this.curTime = curFullTime.split(" ")[1];
  },
  goHome(){
    this.$router.push('/home')
  },
  sortList(){
    
  }
}
};
</script>

<style lang="less" scoped>
h3 {
margin:4px;
font-family: 'Microsoft YaHei';
font-size: 14px;
color:rgba(0,0,0,0.5);
}

.title {
text-align: center;
margin: 16px;
font-family: cursive;
}
</style>
